import { initialize } from 'redux-form';
import { updateEditableCardData } from 'admin/actions/card-editor/update-editable-card-data';
import { updateEditableStory } from 'admin/actions/story/update-editable-story';
import CardEditorIframeTransmitter from 'admin/components/pages/Story/CardEditor/IframeTransmitter';
import { FORM_MODEL } from 'admin/constants/common';
import type { AdminThunkDispatch } from 'admin/reducers';
import { selectEditableStateInfo } from 'admin/reducers/card-editor/selectors';
import type { ToolCallDeps } from './types';

export function bindEditorWrites(
	dispatch: AdminThunkDispatch,
	getEditableState: () => ReturnType<typeof selectEditableStateInfo>
): Pick<ToolCallDeps, 'updateEditableStory' | 'updateEditableCardData'> {
	return {
		updateEditableStory: payload => {
			dispatch(updateEditableStory(payload));
		},
		updateEditableCardData: payload => {
			if (payload.type !== 'full') {
				throw new Error('StoryEditorChat updateEditableCardData requires type: "full"');
			}

			dispatch(updateEditableCardData(payload));

			const { data, symbols, storySettings, storyElements } = payload.value;
			// present write does not push the iframe or reinit EDIT_CARD form.
			CardEditorIframeTransmitter.transmitCardDataToClient({
				data,
				symbols,
				settings: storySettings,
				editableState: getEditableState(),
			});
			CardEditorIframeTransmitter.transmitStoryElementsToClient({
				elements: storyElements,
				editableState: getEditableState(),
			});
			dispatch(
				initialize(FORM_MODEL.EDIT_CARD, {
					...data,
					settings: storySettings,
					symbols,
				})
			);
		},
	};
}
